import _ from 'lodash';
import {
	ADD_EDITABLE_TABLE_ROW, DEL_EDITABLE_TABLE_ROW,
	RESET_EDITABLE_TABLE_STATE,
	SET_EDITABLE_TABLE_STATE,
	UPD_EDITABLE_TABLE_VALUE
} from "../../actions/components";
import {isSameObject} from "../../common/utils/array";
import {getRowError} from "../../common/utils/tables";



const initials = {
	rows:[],
	sort:[],
	filters:[],
	selection:[],
	sorting:[],
	pageSizes:[20, 50, 100],
	onAfterUpdateRow:undefined,
	isDeleteRow:false,
	readOnly:false,
	requiredColumns:[],
	errors:[]
}

const initialState = Object.assign({}, initials)

export default function componentsEditableTableState(state = initialState, action) {
	let ret = Object.assign({}, state, {});
	switch (action.type) {
		case UPD_EDITABLE_TABLE_VALUE:
			const index = _.findIndex(state.rows,{'id':action.payload.id});
			if(index === -1) return state;

			let row = Object.assign({},state.rows[index]);
			row[action.payload.name] = action.payload.value;

			let isUpdate = false;
			if(state.requiredColumns.length){
				state.errors[index] = getRowError(row,state.requiredColumns)
				isUpdate = true;
			}

			if(state.onAfterUpdateRow){
				const bufState = Object.assign({},state);
				row = state.onAfterUpdateRow(row,state);
				if(isSameObject(bufState,state)){
					state.rows[index] = row;

				}
				else{
					state.rows[index] = row;
					isUpdate = true;

				}
			}else{
				state.rows[index] = row;
			}

			return isUpdate ? Object.assign({},state,{}) : state;
		case ADD_EDITABLE_TABLE_ROW:
			const minId = _.filter(ret.rows,'isNewRow').length === 0 ? 0 : Math.min.apply(null,ret.rows.map(function(o){return parseInt(o.id);}));
			const newId = String(minId-1);
			let addRow = {id:newId,isNewRow:true};
			action.payload.columns.forEach(column =>{
				if(column.defaultValue) addRow[column.name] = column.defaultValue;
			})


			addRow = state.onAfterUpdateRow(addRow,state);
			ret.rows.push(addRow);
			ret.errors.push(getRowError(addRow,state.requiredColumns));
			return ret;
		case DEL_EDITABLE_TABLE_ROW:
			const i = _.findIndex(state.rows,{'id':action.payload.id});
			if(i === -1) return state;
			ret.rows.splice(i,1);
			ret.errors.splice(i,1);
			ret.isDeleteRow = true;
			state.onAfterUpdateRow({})
			return ret;
		case SET_EDITABLE_TABLE_STATE:
			return Object.assign({}, state, action.payload);
		case RESET_EDITABLE_TABLE_STATE:
			for(const key in initials){
				state[key] = initials[key];
			}
			return state;

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/components/editable-table.js